var map = {
	"./china.svg": "695f",
	"./city.svg": "06b6",
	"./city_2560.svg": "759a",
	"./city_768.svg": "8a18",
	"./indonesia.svg": "429f",
	"./mega-image.svg": "0966",
	"./thailand.svg": "8efa",
	"./ufo.svg": "8c12",
	"./ufo_1075.svg": "4844",
	"./ufo_768.svg": "5a63",
	"./united-kingdom.svg": "777b",
	"./vietnam.svg": "c573"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a612";